import Typography from '@heycar-uikit/typography';
import styled from 'styled-components';

export const WrittenBySt = styled(Typography).attrs({ variant: 'body3' })``;
